<template>
  <div>
    <div
      class="name"
      :class="{
        required: field.required,
      }"
    >
      {{ field.name }}
    </div>
    <div>
      <div v-for="variant in variants" :key="variant.id" class="variant">
        <c-radio
          :value="variant.id === localValue"
          :label="variant.text"
          type="radio"
          :name-radio-group="`field-radio-${_uid}`"
          @input="updateValue($event, variant.id)"
        />
      </div>
    </div>
    <error-feedback v-if="error" :text="error" />
  </div>
</template>

<script>
import CRadio from "@/components/controls2/Switcher";
import ErrorFeedback from "@/components/error-feedback";
import { FieldVariant } from "@/domains/profile/models/ProfileFieldVariant";

export default {
  components: { CRadio, ErrorFeedback },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: null,
    };
  },
  computed: {
    dictionary() {
      return this.$store.state.profile.dictionaries[this.field.parentId] || [];
    },
    variants() {
      return this.dictionary.map(FieldVariant);
    },
  },
  watch: {
    value(v) {
      this.setData(v);
    },
    localValue(v) {
      this.$emit("input", v ? { value: [v] } : null);
      if (this.inited) this.$emit("change");
    },
  },
  created() {
    this.$store.dispatch("profile/getDictionary", { fieldId: this.field.parentId });
    if (this.value) this.setData(this.value);
 
  },
  methods: {
    updateValue(event, newValue) {
      if (event === false) return;
      if (this.localValue === newValue) return;
      this.localValue = newValue;
    },
    setData(value) {
      if (!value) return;
      this.inited = false;
      const [el] = value.value || [];
      if (el !== this.localValue) this.localValue = el;
      this.$nextTick(() => {
        this.inited = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.name {
  font-size: 15px;
  margin-bottom: 16px;
  line-height: 1.4;

  &.required {
    &:after {
      content: "*";
      color: red;
    }
  }
}
.variant:not(:last-child) {
  margin-bottom: 20px;
}
</style>
